<template>
  <v-card class="mt-6" rounded="md" outlined>
    <v-card-text class="py-0">
      <v-row>
        <v-col cols="12">
          <v-list>
            <v-list-item class="px-1 mb-4">
              <v-list-item-title class="text--secondary body-1 font-weight-medium">Detalle</v-list-item-title>
            </v-list-item>
            <template v-if="instance.source.usage === 'reusable'">
              <v-list-item class="px-1">
                <v-list-item-title>Método de pago</v-list-item-title>
                <v-list-item-subtitle class="text-right body-2 font-weight-medium">{{instance.source.card.brand}} - {{instance.source.card.last4}}</v-list-item-subtitle>
              </v-list-item>
            </template>
            <template v-else-if="instance.source.usage === 'single' && ['redirect', 'none'].includes(instance.source.gateway.flow)">
              <v-list-item class="px-1">
                <v-list-item-title>Proveedor de pago</v-list-item-title>
                <v-list-item-subtitle class="text-right body-2 font-weight-medium">{{instance.source.gateway.name}}</v-list-item-subtitle>
              </v-list-item>
              <v-list-item class="px-1" v-if="instance.source.card">
                <v-list-item-title>Método de pago</v-list-item-title>
                <v-list-item-subtitle class="text-right body-2 font-weight-medium">{{instance.source.card.brand}} - {{instance.source.card.last4}}</v-list-item-subtitle>
              </v-list-item>
              <v-list-item class="px-1">
                <v-list-item-title>Funding</v-list-item-title>
                <v-list-item-subtitle class="text-right body-2 font-weight-medium">{{instance.intent.funding}}</v-list-item-subtitle>
              </v-list-item>
            </template>
            <template v-if="instance.source.usage === 'single' && instance.source.gateway.flow == 'receiver'">
              <template v-if="instance.source.id === 'offline_payment'">
                <v-list-item class="px-1">
                  <v-list-item-title>Método de pago</v-list-item-title>
                  <v-list-item-subtitle class="text-right body-2 font-weight-medium">Externo</v-list-item-subtitle>
                </v-list-item>
                <v-list-item class="px-1">
                  <v-list-item-title>Funding</v-list-item-title>
                  <v-list-item-subtitle class="text-right body-2 font-weight-medium">
                    <template v-if="instance.source.offline_payment.method === 'bank_transfer'">Transferencia bancaria</template>
                    <template v-else-if="instance.source.offline_payment.method === 'cash'">Efectivo</template>
                    <template v-else-if="instance.source.offline_payment.method === 'check'">Cheque</template>
                  </v-list-item-subtitle>
                </v-list-item>
              </template>
              <template v-else-if="instance.source.gateway.id === 'ach_transfer'">
                <v-list-item class="px-1">
                  <v-list-item-title>Método de pago</v-list-item-title>
                  <v-list-item-subtitle class="text-right body-2 font-weight-medium">Transferencia bancaria</v-list-item-subtitle>
                </v-list-item>
              </template>
            </template>
            <template v-if="instance.invoice && Object.keys(instance.invoice).length">
              <v-list-item class="px-1" v-for="(line, i) in instance.invoice.lines" :key="i">
                <v-list-item-title>{{line.name}}</v-list-item-title>
                <v-list-item-subtitle class="text-right">{{line.total}}</v-list-item-subtitle>
              </v-list-item>
              <v-divider />
              <v-list-item class="px-1">
                <v-list-item-title>Subtotal</v-list-item-title>
                <v-list-item-subtitle class="text-right">{{instance.invoice.subtotal | currency(instance.currency)}}</v-list-item-subtitle>
              </v-list-item>
              <v-list-item class="px-1">
                <v-list-item-title>Descuento</v-list-item-title>
                <v-list-item-subtitle class="text-right">{{instance.invoice.discount | number(false)}}</v-list-item-subtitle>
              </v-list-item>
              <v-divider />
              <v-list-item class="px-1">
                <v-list-item-title>Exento</v-list-item-title>
                <v-list-item-subtitle class="text-right">{{instance.invoice.exempt | currency(instance.currency)}}</v-list-item-subtitle>
              </v-list-item>
              <v-list-item class="px-1">
                <v-list-item-title>Neto</v-list-item-title>
                <v-list-item-subtitle class="text-right">{{instance.invoice.amount | currency(instance.currency)}}</v-list-item-subtitle>
              </v-list-item>
              <v-divider />
              <v-list-item class="px-1">
                <v-list-item-title>Impuestos</v-list-item-title>
                <v-list-item-subtitle class="text-right">{{instance.invoice.tax | currency(instance.currency)}}</v-list-item-subtitle>
              </v-list-item>
              <v-divider />
            </template>
            <v-list-item class="px-1">
              <v-list-item-title>Total</v-list-item-title>
              <v-list-item-subtitle class="text-right body-2 font-weight-medium">{{instance.amount | currency(instance.currency)}} {{instance.currency}}</v-list-item-subtitle>
            </v-list-item>
            <v-list-item class="px-1 mt-4">
              <v-list-item-title>¿Tienes preguntas? contáctanos a {{account.email}}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
import ReminderViewMixin from '@/mixins/ReminderViewMixin'
export default {
  mixins: [
    ReminderViewMixin
  ]
}
</script>